import { componentRoutes } from "../constants/componentRoutes"

export const sidebarLinks = [
    {
        label: 'Blogs',
        icon: 'MonitorDot', // Replace with actual icon class
        link: componentRoutes.blog,
        children: []
    },
    {
        label: 'Add Blog',
        icon: 'MonitorDot', // Replace with actual icon class
        link: componentRoutes.addBlog,
        children: []
    },
    {
        label: 'Contact Us',
        icon: 'MonitorDot', // Replace with actual icon class
        link: componentRoutes.contactUs,
        children: []
    },
    {
        label: 'Events',
        icon: 'MonitorDot', // Replace with actual icon class
        link: componentRoutes.events,
        children: []
    },
    {
        label: 'Meta Information',
        icon: 'MonitorDot', // Replace with actual icon class
        link: componentRoutes.metaInfo,
        children: []
    },
    {
        label: 'Faq',
        icon: 'MonitorDot', // Replace with actual icon class
        link: componentRoutes.faq,
        children: []
    },
    {
        label: 'News Letters',
        icon: 'MonitorDot', // Replace with actual icon class
        link: componentRoutes.newsletters,
        children: []
    },
    {
        label: 'News',
        icon: 'MonitorDot', // Replace with actual icon class
        link: componentRoutes.newsList,
        children: []
    },

    {
        label: 'LogOut',
        icon: 'MonitorDot', // Replace with actual icon class
        link: componentRoutes.root,
        children: []
    },

];


// ✅ conditionally push Logs link if NOT admin
const userRole = localStorage.getItem("admin_role"); // or "userType", "admin", etc.

if (userRole == "admin") {

    const userItem = {
        label: "User List",
        icon: "MonitorDot", // Replace with actual icon class
        link: componentRoutes.userList,
        children: []
    };

    const newItem = {
        label: "Logs",
        icon: "MonitorDot",
        link: componentRoutes.logs_list,
        children: []
    };


    // 👉 Insert Logs at the first index
    sidebarLinks.unshift(userItem);

    // 👉 Insert User List at the second-last index
    const insertIndex = Math.max(sidebarLinks.length - 1, 0);
    sidebarLinks.splice(insertIndex, 0, newItem);
}